export default "__VITE_ASSET__q0ksBi9R__"